module.exports = __webpack_public_path__ + "img/Ideen_Lacandonia.dd91b2cd.png";